import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":schoolId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "year-group-manager" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
});
